module.exports = {
  key: 'import',
  icon: 'md-cloud-upload',
  name: '导入任务',
  do({tasks}, task_list) {
    if (!task_list) {
      return;
    }
    if (Array.isArray(task_list) == false) {
      task_list = [task_list];
    }
  },
};
